import React from 'react';

const GlassCard = ({ children, className = '', hover = true, selected = false, variant = 'default', ...props }) => {
  const variantStyles = {
    default: 'bg-[#2a2a2a] border-[#404040]',
    paperhand: 'bg-gradient-to-br from-[#2a1a1a] to-[#2a2a2a] border-red-500/30',
    diamondhand: 'bg-gradient-to-br from-[#1a2a1a] to-[#2a2a2a] border-green-500/30',
    highlight: 'bg-gradient-to-br from-[#2a1a2a] to-[#2a2a2a] border-green-500/50 animate-pulse-glow',
  };

  return (
    <div
      className={`
        ${variantStyles[variant] || variantStyles.default}
        border
        rounded-xl
        ${hover ? 'glass-hover' : ''}
        ${selected ? 'border-green-500 shadow-lg shadow-green-500/20' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default GlassCard;
